import React from "react"
import { Link } from "react-router-dom"
import { Col, Row } from "reactstrap"

import verificationImage from "assets/images/verification-img.png"

export default function Success() {
  return (
    <>
      <div className="account-pages my-5 pt-5">
        <Row>
          <Col lg="12">
            <div className="text-center mb-5">
              {<h1 className="display-2 font-weight-medium">&nbsp;</h1>}
              <h4>{"Evaluación y datos guardados con éxito!"}</h4>
              <div className="mt-5 text-center">
                <Link className="btn btn-primary " to="/agro/dashboard">
                  Volver al inicio
                </Link>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="8" xl="6">
            <div>
              <center>
                <img src={verificationImage} height={"300px"} alt="" />
              </center>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}
